import React from 'react';
import { useImpressionManager } from '@fiverr-private/impressionable';
import EntryWrapper from '../../../components/EntryWrapper';
import TopFolder from '../../../components/v17/TopFolder';
import PopularServices from '../../../components/v17/PopularServices';
import ProSection from '../../../components/v17/ProSection';
import FAQs from '../../../components/v17/FAQs';
import CTAComponent from '../../../components/v17/CTA';
import Testimonials from '../../../components/v17/Testimonials';

const LoggedOutHomepageClient: React.FC = () => {
  useImpressionManager();

  return (
    <EntryWrapper isDarkTheme>
      <TopFolder />
      <Testimonials />
      <ProSection />
      <PopularServices />
      <FAQs />
      <CTAComponent />
    </EntryWrapper>
  );
};

export default LoggedOutHomepageClient;
